import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}
export async function submitMentor(payload) {
  const { data } = await api.post("/mentor", payload);
  return data;
}
export async function submitCareer(payload) {
  const { data } = await api.post("/career", payload);
  return data;
}
export async function fetchAssessmentMeta() {
  const { data } = await api.get("/assessment/meta");
  return data;
}
export async function checkAssessmentMobile(mobile) {
  const { data } = await api.post("/assessment/check", { mobile });
  return data;
}
export async function startAssessment(payload) {
  const { data } = await api.post("/assessment/start", payload);
  return data;
}
export async function submitAssessment(payload) {
  const { data } = await api.post("/assessment/submit", payload);
  return data;
}
export async function claimLaunchOffer(payload) {
  const { data } = await api.post("/launch-offer/claim", payload);
  return data;
}
